// INTERNAL: Use StorageService (storage.service.ts) instead of the functions in this file

class LocalStorageUtils {
    public getUserOrgLocalStorageData(unprefixedKey: string, userId: uuid, orgId: uuid): any {
        return this.getLocalStorageData(this.getPrefixedKeyBy(unprefixedKey, userId, orgId));
    }

    public getUserLocalStorageData(unprefixedKey: string, userId: uuid): any {
        return this.getLocalStorageData(this.getPrefixedKeyBy(unprefixedKey, userId));
    }

    public setUserOrgLocalStorageData(unprefixedKey: string, userId: uuid, orgId: uuid, data): void {
        this.setLocalStorageData(this.getPrefixedKeyBy(unprefixedKey, userId, orgId), data);
    }

    public setUserLocalStorageData(unprefixedKey: string, userId: uuid, data: any): void {
        this.setLocalStorageData(this.getPrefixedKeyBy(unprefixedKey, userId), data);
    }


    private setLocalStorageData(key: string, data: any): void {
        localStorage.setItem(key, JSON.stringify(data));
    }

    private getLocalStorageData(key: string): any {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : undefined;
    }

    private getPrefixedKeyBy(unprefixedKey: string, userId: uuid, orgId?: uuid): string {
        const userPrefix = userId ? userId + "_" : "";
        const orgPrefix = orgId ? orgId + "_" : "";
        return userPrefix + orgPrefix + unprefixedKey;
    }
}

export const localStorageUtils = new LocalStorageUtils(); //Singleton
